import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Snackbar,
  Alert,
  Button,
  Stack,
  Typography,
  Link, Paper 
} from "@mui/material";
import { ChangeLogContext } from "../../common/context/ChangeLogContext";
import { Trans, useTranslation } from "react-i18next";
import Translator from "../I18n/Translator";
import { UsuarioContext } from "../../common/context/UsuarioContext";

export default function ChangeLogNotification() {

  const { t } = useTranslation();

  const navigate = useNavigate();

  const { logado } = useContext(UsuarioContext);

  const {
    hasNewChangeLog,
    latestChangeLog,
    markAsSeen,
    showNotice,
    fixedNotice,
    dismissNotice,
  } = useContext(ChangeLogContext);

  const handleGoToChangeLog = () => {
    markAsSeen();
    navigate("/changelog");
  };

  if (!logado) return null;

   if (showNotice) {
    return (
      <Snackbar
        open
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Paper
      variant="outlined"
      sx={{
        width: 610,
        borderRadius: 5,
        borderColor: "info.main",
        borderWidth: 2.5, 
        p: 2.5,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
      }}
    >
          <Typography
            variant="subtitle2"
            fontWeight={700}
            fontStyle="italic"
            textAlign="center"
            display="block"
            mb={0.5}
          >
            {t(fixedNotice.titleKey)}   {/* "INFORMAÇÃO" */}
          </Typography>

          <Typography variant="body2" textAlign="center">
            {t(fixedNotice.messageKey)}
          </Typography>

          {fixedNotice.learnMoreUrl && (
            <Typography variant="body2" textAlign="center" mt={1}>
              <Link
                href={fixedNotice.learnMoreUrl}
                target="_blank"
                rel="noopener"
                underline="always"
                color="inherit"
              >
                {t("dashboard.saiba_mais")}
              </Link>
            </Typography>
          )}
        <Button
        size="small"
        variant="outlined"
        color="info"
        onClick={dismissNotice}
        sx={{ mt: 0.5, width: "fit-content" }}
      >
        {t("dashboard.entendido")}
      </Button>
    </Paper>
      </Snackbar>
    );
  }

  // Fallback: comportamento original de novo changelog
  if (!hasNewChangeLog) return null;

  return (
    <Snackbar
      open={hasNewChangeLog}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        severity="info"
        variant="filled"
        sx={{ width: "100%" }}
        action={
          <Stack direction="row" spacing={1}>
            <Button
              color="inherit"
              size="small"
              onClick={handleGoToChangeLog}
            >
              <Translator path="dashboard.ver_mudancas" />
            </Button>
            <Button
              color="inherit"
              size="small"
              onClick={markAsSeen}
            >
              <Translator path="dashboard.ignorar" />
            </Button>
          </Stack>
        }
      >
        <Translator path="dashboard.novo_log_disponivel" />
        {latestChangeLog?.versao &&
          ` (v${latestChangeLog.versao})`}
      </Alert>
    </Snackbar>
  );
}
